module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage"
  }, [_c('a', {
    attrs: {
      "id": "title122"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-c-br"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("For Roland C. Greefkes, extraordinary creator")]), _vm._v(" "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("of magical flower gates, with many heartfelt thanks")]), _vm._v(" "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("from Hannah and myself for our own")]), _vm._v(" "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("enchanted protection.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d07330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429911641_ded01.vue
// module id = 69
// module chunks = 0